import { React, useState } from "react";
import axios from "axios";
import Title from "./Title";
import Input from "./Input";
import RandomCard from "./randomCard";
import data from "../extra.json";
import "./css/home.css";
import Chats from "./Chats";

function Home() {
  const [userSearch, setUserSearch] = useState([]);
  const [BotOutput, setBotOutput] = useState([]);
  const [activeModal, setActiveModal] = useState(null);

  const onSubmitValue = (value) => {
    setUserSearch([...userSearch, value]);
    axios
      .get("https://opinion-project-backend.onrender.com/" + value)
      .then((data) => {
        setBotOutput([...BotOutput, data.data]);
      })
      .catch((error) => console.log(error));
  };

  const handleCardClick = (text) => {
    if (text === "How to use?") setActiveModal("use");
    else setActiveModal("works");
  };

  return (
    <div className="app-container">
      <Title />

      <main className="main-content">
        <div className="content-viewport">
          {userSearch.length === 0 ? (
            <div className="welcome-screen">
              <div className="hero-section">
                <h1>How can I help you today?</h1>
                <p className="status-note">
                  Processing usually takes 30-40 seconds. We appreciate your
                  patience.
                </p>
              </div>

              <div className="suggestions-grid">
                {data.randomCards.map((item, index) => (
                  <RandomCard
                    key={index}
                    heading={item.heading}
                    para={item.para.slice(0, 15) + "...."}
                    onCardClick={handleCardClick}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className="chat-container">
              <Chats search={userSearch} output={BotOutput} />
            </div>
          )}
        </div>

        <div className="input-wrapper">
          <Input onSubmitValue={onSubmitValue} />
          <p className="credits">Designed by Parth Dudani & Samihan Joshi</p>
        </div>
      </main>

      {activeModal && (
        <div className="modal-overlay" onClick={() => setActiveModal(null)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setActiveModal(null)}>
              ×
            </button>
            <h2 className="modal-title">
              {activeModal === "use" ? "How to use?" : "How It Works?"}
            </h2>
            <p className="modal-text">
              {activeModal === "use"
                ? "Input: Enter the topic you want to analyze... (e.g., 'Breaking Bad web series review')"
                : "Data Collection: We retrieve top YouTube videos and analyze sentiments using Google Gemini Gen AI..."}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
